module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content",
    staticStyle: {
      "padding-left": "0px",
      "padding-right": "0px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8"
  }, [_c('router-link', {
    attrs: {
      "to": "/products-view"
    }
  }, [_c('p', {
    staticClass: "sg-top"
  }, [_c('i', {
    staticClass: "fa fa-chevron-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("   " + _vm._s(this.$store.state.viewVideoName))])])], 1)]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "embed-responsive embed-responsive-16by9",
    attrs: {
      "id": "parent"
    }
  }, [_c('iframe', {
    staticClass: "embed-responsive-item",
    attrs: {
      "id": "player1",
      "src": "",
      "src": _vm.catalogueUrl,
      "allow": "autoplay; fullscreen",
      "frameborder": "0",
      "webkitallowfullscreen": "",
      "mozallowfullscreen": "",
      "allowfullscreen": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "sg-pname"
  }, [_vm._v(_vm._s(this.$store.state.viewVideoName))]), _vm._v(" "), _c('p', {
    staticClass: "sg-disco"
  }, [_vm._v(_vm._s(this.$store.state.viewVideoDescription))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24f54d5c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/user/SingleProductVideo.vue
// module id = 2073
// module chunks = 1